/* eslint-disable react/no-array-index-key */
import ArticleCard from "component/design-system/article-card/ArticleCard";
import Slider from "component/design-system/carousel/Slider";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import Text from "component/design-system/typography/Text";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import HideIf from "util/HideIf";
import styles from "./article.module.scss";

function ArticleGuide({
  articles,
  showTitle = true,
  href = "/blog",
  tileWidth,
  isDate = false,
  showArrowOnHover,
  showScrollOnHover,
  grayBackground,
}: any) {
  const { t } = useTranslation("common");
  if (!articles || !articles.length) {
    return null;
  }

  return (
    <div id="articles" className={styles.article_guide_container}>

      <div className="col-md-4 col-xs-12">
        {showTitle && (
          <Text
            size={2}
            bold
            className="text-left"
            style={{ lineHeight: "1.4", fontSize: "calc(2.4 * var(--safari-root-font, 10px))" }}
          >
            {t("Buying Guides & Articles on Auto Parts")}
          </Text>
        )}

        <PAText
          component="p"
          className="text-left"
          color="light-grey"
          style={{ lineHeight: "1.4" }}
          fontSize={FONT_SIZE[2]}
        >
          {t("articles_content_1")}
        </PAText>

        <Link
          href={href}
          prefetch={false}
          className="d-flex flex-column"
          title="Choose car parts wisely by reading our specialized guides and articles"
        >

          <PAText
            color="success-secondary"
            fontSize={FONT_SIZE[2]}
            bold
            className="text-left m-t-10 m-b-10"
          >
            {`${t("Read all Guides & Articles")}`}

          </PAText>

        </Link>
      </div>

      <div className={`col-md-8 col-xs-12 ${styles.slider_wrapper}`}>

        <HideIf show={articles}>

          <Slider
            tileWidth={tileWidth}
            // autoplay
            showArrowOnHover={showArrowOnHover}
            showScrollOnHover={showScrollOnHover}
            liClass={`${styles.slider_li_class} ${grayBackground ? styles.gray_background : ""}`}
          >
            {isDate
              ? articles.map((article: any, index: number) => (
                <div className={styles.slider_item} key={index}>
                  <ArticleCard
                    articleUrl={article.articleUrl}
                    imageUrl={article.imageUrl}
                    dateOfPublish={article.dateOfPublish}
                    title={article.title}
                    description={article.description}
                    isDate={isDate}
                    alt={`Explore Our Informative Resource: ${article.title}`}
                  />
                </div>
              ))
              : articles
                ?.filter((_: any) => _.linkDetails)
                .map((article: any, index: number) => {
                  const {
                    url, imageUrl, metaTitle, headers, metaDescription, linkDetails,
                  } = article;
                  const { title, description, image } = linkDetails || { title: metaTitle, description: metaDescription, image: imageUrl };
                  return (
                    <div className={styles.slider_item} key={index}>
                      <ArticleCard
                        articleUrl={url}
                        imageUrl={image}
                        title={headers?.h1 || title}
                        description={description}
                        isDate={isDate}
                        alt={`Explore Our Informative Resource: ${article.title}`}
                      />
                    </div>
                  );
                })}
          </Slider>
        </HideIf>
      </div>
    </div>
  );
}

export default ArticleGuide;
